import { useMemo } from 'react';
import type { WorkOrderDetailViewModel } from '@api/enterprise/openapi/models';
import { WorkOrderDetailStatus } from '../types';

type StatusCounts = {
  [WorkOrderDetailStatus.COMPLETE]: number;
  [WorkOrderDetailStatus.INCOMPLETE]: number;
  [WorkOrderDetailStatus.SKIPPED]: number;
  [WorkOrderDetailStatus.BACKORDERED]: number;
};

export const useTaskProgress = (details: WorkOrderDetailViewModel[]) => {
  return useMemo(() => {
    const totalTasks = details.length;

    // Initialize status counts
    const statusCounts: StatusCounts = {
      [WorkOrderDetailStatus.COMPLETE]: 0,
      [WorkOrderDetailStatus.INCOMPLETE]: 0,
      [WorkOrderDetailStatus.SKIPPED]: 0,
      [WorkOrderDetailStatus.BACKORDERED]: 0
    };

    // Count statuses, normalizing variations
    details.forEach(detail => {
      const normalizedStatus = detail.status?.toUpperCase();
      switch (normalizedStatus) {
        case 'COMPLETE':
        case 'COMPLETED':
          statusCounts[WorkOrderDetailStatus.COMPLETE]++;
          break;
        case 'SKIPPED':
          statusCounts[WorkOrderDetailStatus.SKIPPED]++;
          break;
        case 'BACKORDERED':
        case 'BACK_ORDERED':
          statusCounts[WorkOrderDetailStatus.BACKORDERED]++;
          break;
        case 'INCOMPLETE':
        case 'PENDING':
        case 'NOT_STARTED':
        default:
          statusCounts[WorkOrderDetailStatus.INCOMPLETE]++;
          break;
      }
    });

    const completedTasks = statusCounts[WorkOrderDetailStatus.COMPLETE];

    return {
      totalTasks,
      completedTasks,
      statusCounts,
      progressText: `${completedTasks} of ${totalTasks} complete`
    };
  }, [details]);
};
